import axios from "axios";
import { jwtDecode } from "jwt-decode";

export interface JwtPayload {
  exp?: number; // Expiration time in seconds
  iat?: number; // Issued at
  sub?: string; // Subject (user id, etc.)
  [key: string]: any; // Any additional claims
}

export function isValidJwtFormat(token: string): boolean {
  if (!token || typeof token !== "string") return false;

  const parts = token.split(".");
  if (parts.length !== 3) return false;

  // Check if all parts are non-empty
  return parts.every((part) => part.trim().length > 0);
}

export function getTokenPayloadSafely(
  token: string | null | undefined,
): JwtPayload | null {
  if (!token || !isValidJwtFormat(token)) {
    console.warn("Invalid or missing token format");
    return null;
  }

  try {
    return jwtDecode<JwtPayload>(token);
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
}

const apiClient = axios.create({
  baseURL:
    process.env.REACT_APP_API_BASE_URL || "http://test.hrms-api.oagb.et/",
  headers: {
    "Content-Type": "application/json",
  },
  // withCredentials: true, // optional: if using cookies for auth
});

apiClient.interceptors.request.use((config) => {
  // const token: LoginAccount | null = sessionStorage.getItem("authToken")
  //   ? getTokenPayloadSafely(sessionStorage.getItem("authToken") as string)
  //   : null;
  if (sessionStorage.getItem("authToken")) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${sessionStorage.getItem(
      "authToken",
    )}`;
  }
  return config;
});

export default apiClient;
